export enum Brand {
    Undetected = 0,
    FNB = 1,
    RMB = 2,
}
